module.exports = __webpack_public_path__ + "static/media/logo_gray.4de09e36.svg";